import type { ReactElement } from 'react';

import type { ThemePreference } from './theme';
import { THEME_PREFERENCES } from './theme';
import { useTheme } from './useTheme';

/**
 * 主題切換：三個選項全部直接可點（分段控制），刻意**不做**成單鍵循環——
 * 使用者想從深色直接切到淺色時，不該還被迫經過「跟隨系統」。
 */

const LABELS: Record<ThemePreference, string> = {
  light: '淺色',
  dark: '深色',
  system: '系統',
};

const ICONS: Record<ThemePreference, string> = {
  light: '☀',
  dark: '☾',
  system: '◐',
};

export function ThemeToggle(): ReactElement {
  const { preference, resolved, setPreference } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="主題"
      data-testid="theme-toggle"
      data-theme-preference={preference}
      data-theme-resolved={resolved}
      className="flex items-center gap-0.5 rounded border border-slate-300 p-0.5 dark:border-slate-600"
    >
      {THEME_PREFERENCES.map((option) => {
        const selected = option === preference;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={selected}
            title={
              option === 'system'
                ? `跟隨系統（目前：${resolved === 'dark' ? '深色' : '淺色'}）`
                : LABELS[option]
            }
            data-testid={`theme-option-${option}`}
            onClick={() => setPreference(option)}
            className={`rounded px-1.5 py-0.5 leading-none ${
              selected
                ? 'bg-blue-600 text-white'
                : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'
            }`}
          >
            <span aria-hidden="true">{ICONS[option]}</span>
            <span className="ml-1">{LABELS[option]}</span>
          </button>
        );
      })}
    </div>
  );
}
